<template>
  <div :style="`height: ${height}px`">
    <div
      ref="fixedBottom"
      class="fixed-bottom"
      :class="{
      'fixed': isFixedScrollBar,
      'default-width': !isFixedScrollBar
    }"
    >
      <div
        :class="{hide: !isScrollX || !isFixedScrollBar}"
        ref="fixedScrollBar"
        class="fixed-scroll-bar"
        @mousedown="mouseEvent"
        @mouseup="mouseEvent"
        @scroll="scrollSlideBar">
        <div ref="slideBar" class="slide-bar"></div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fixedBottomComponents',
  props: {
    // 底部元素高度 站位放抖动
    height: {
      default: 52
    },
    // 接收 HTMLElement、VueComponent两种类型
    el: {
      default: null,
      required: true
    }
  },
  data() {
    return {
      isScrollX: false,
      isFixedScrollBar: false
    }
  },
  watch: {
    // 初始传入el可能为null
    el() {
      this.init()
    }
  },
  mounted() {
    this.slideBarMousedownFlag = false // 是否为slideBar滚动条滚动
    this.actualEl = null // 实际的表格dom, 当el为VueComponent时, actualEl = el.$el
    this.elTableBody = null // 当el为VueComponent时有值, el-table下的el-table__body节点
    this.appMain = document.getElementsByClassName('app-main')[0]
    this.fixedScrollBar = this.$refs.fixedScrollBar
    this.slideBar = this.$refs.slideBar
    this.fixedBottom = this.$refs.fixedBottom
    this.bodyClientHeight = document.body.clientHeight - this.fixedBottom.clientHeight
    this.bodyWrapperBindEvent = false // bodyWrapper是否已经绑定了scroll事件 用于防止重复绑定
    this.createIframeHtml()
    window.addEventListener('scroll', this.scrollY)
    window.addEventListener('resize', this.resize)
    if (this.el) {
      this.init()
    }
  },
  methods: {
    init() {
      if (this.el.$el) {
        this.actualEl = this.el.$el
        this.elTableBody = this.el.$el.getElementsByClassName('el-table__body')[0]
      } else {
        this.actualEl = this.el
      }
      this.resize()
    },
    createIframeHtml() {
      this.iframeHtml = document.createElement('iframe')
      this.iframeHtml.style.cssText = `
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: 0;
        margin: 0;
        display: block;
        z-index: -999;
    `
      this.appMain.appendChild(this.iframeHtml)
      const iframeHtml = this.iframeHtml.contentWindow || this.iframeHtml
      iframeHtml.addEventListener('resize', this.resizeIframeHtml)
    },
    // 检查容器是否需要fixed
    checkContainerFixed() {
      setTimeout(() => {
        this.isFixedScrollBar = this.actualEl.getBoundingClientRect().bottom > this.bodyClientHeight
      }, 10)
    },
    scrollY() {
      this.checkContainerFixed()
    },
    scrollElTableBody(e) {
      if (!this.slideBarMousedownFlag) {
        this.fixedScrollBar.scrollLeft = e.target.scrollLeft
      }
    },
    scrollSlideBar(e) {
      if (this.slideBarMousedownFlag) {
        this.el.bodyWrapper.scrollLeft = e.target.scrollLeft
      }
    },
    mouseEvent(e) {
      this.slideBarMousedownFlag = e.type === 'mousedown'
    },
    // 只考虑el-table有横向滚动条的情况
    setScrollBar() {
      this.isScrollX = this.el.layout.scrollX
      if (!this.el.layout.scrollX) {
        return
      }
      this.fixedScrollBar.style.width = this.actualEl.clientWidth + 'px'
      this.slideBar.style.width = this.elTableBody.clientWidth + 'px'
      if (!this.bodyWrapperBindEvent) {
        this.el.bodyWrapper.addEventListener('scroll', this.scrollElTableBody)
        this.bodyWrapperBindEvent = true
      }
    },
    resize() {
      this.fixedBottom.style.width = this.appMain.clientWidth + 'px'
      this.fixedBottom.style.left = this.appMain.offsetLeft + 'px'
      this.bodyClientHeight = document.body.clientHeight - this.fixedBottom.clientHeight
      if (this.el) {
        this.checkContainerFixed()
        if (this.el.$el) {
          this.setScrollBar()
        }
      }
    },
    resizeIframeHtml() {
      this.checkContainerFixed()
    }
  },
  beforeDestroy() {
    this.el && this.el.bodyWrapper && this.el.bodyWrapper.removeEventListener('scroll', this.scrollElTableBody)
    this.iframeHtml && this.iframeHtml.removeEventListener('resize', this.resizeIframeHtml)
    window.removeEventListener('resize', this.resize)
    window.removeEventListener('scroll', this.scrollY)
  }
}
</script>

<style scoped lang="less">
.fixed-bottom{
  overflow: hidden;
  user-select: none;
  width: 100%;
  bottom: 0;
  background-color: #fff;
  box-sizing: border-box;
  z-index: 50;
  padding-bottom: 10px;
  @media screen and (max-width: 1200px) {
    padding-left: 20px;
    position: relative !important;
    left: 0 !important;
    .fixed-scroll-bar {
      display: none;
    }
  }
  &.fixed{
    border-top: 1px solid #F5F7FA;
    position: fixed;
    padding: 0 40px 20px;
  }
  &.default-width {
    width: 100% !important;
  }
  .fixed-scroll-bar{
    user-select: none;
    position: fixed;
    bottom: 60px;
    height: 8px;
    background-color: #F5F7FA;
    z-index: 121;
    border-radius: 8px;
    overflow: scroll;
    &.hide{
      visibility: hidden;
      opacity: 0;
    }
    .slide-bar{
      background-color: #e4e7ed;
      height: 8px;
      border-radius: 8px;
      z-index: 111;
      &:hover{
        background: #DCDFE6;
      }
    }
    &::-webkit-scrollbar{
      width: 1px;
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #F5F7FA;
    }
  }
}
</style>
